import { useSelector } from "react-redux";
import { IExperts } from "redux/reducers/expertsListSlice";
import { RootSliceType } from "redux/reducers/rootReducer";

export const useExpertsSelectors = () => {
  const favoriteExpertsList = useSelector<
    RootSliceType,
    IExperts["favoriteExperts"]
  >((state) => state.experts.favoriteExperts);

  const allExperts = useSelector<RootSliceType, IExperts["allExperts"]>(
    (state) => state.experts.allExperts
  );
  const allExpertsLoading = useSelector<
    RootSliceType,
    IExperts["loadingAllExperts"]
  >((state) => state.experts.loadingAllExperts);
  const favouriteExpertsLoading = useSelector<
    RootSliceType,
    IExperts["loadingFavouriteExperts"]
  >((state) => state.experts.loadingFavouriteExperts);

  const teacher = useSelector<RootSliceType, IExperts["teacher"]>(
    (state) => state.experts.teacher
  );

  const loading = useSelector<RootSliceType, IExperts["loading"]>(
    (state) => state.experts.loading
  );

  const bookmarkedExpertsList = useSelector<
    RootSliceType,
    IExperts["bookmarkedExperts"]
  >((state) => state.experts.bookmarkedExperts);

  return {
    favoriteExpertsList,
    allExperts,
    teacher,
    allExpertsLoading,
    favouriteExpertsLoading,
    loading,
    bookmarkedExpertsList
  };
};

export default useExpertsSelectors;
